export const SvgPathAttributes = {
  empty: {
    dAttributeToLink:
      'M12.03 0L8.29 7.92 0 9.19l6 6.15-1.42 8.68 7.45-4.14 6.83 2.79-1.54-7.42 5.46-5.54-7.33-1.25-1.88-4.25L12.03 0z',
    dAttributePath: '',
  },
  quarter: {
    dAttributeToLink: 'M8.95 7.83L0  9.19l6 6.15-1.42 8.68 4.37-2.64V7.83z',
    dAttributePath: 'M-2.44-2.06h14.75V24H-2.44z',
  },
  half: {
    dAttributePath: 'M-2.44-2.06h14.75V24H-2.44z',
  },
  threeQuarter: {
    dAttributePath: 'M0-2.06h17.08V24H0z',
  },
  full: {
    dAttributePath: 'M0 0h24v24H0z',
  },
  starPathDAttribute:
    'M12 2.37l2.8 6 .2.46.53.08 6.37 1-4.64 4.76-.33.33.07.5 1.08 6.65-5.6-3.15-.48-.22-.48.22-5.62 3.15L7 15.5l.07-.5-.35-.36-4.65-4.76 6.37-1L9 8.83l.2-.48 2.8-6M12 0L8.29 7.92 0 9.19l6 6.15L4.58 24 12 19.92 19.42 24 18 15.34l6-6.15-8.29-1.27L12 0z',
};

export default SvgPathAttributes;
